import { NetworkRequestOutcome } from '@/parsing/parsers/common/NetworkRequestOutcome';

export enum NetworkOutcomeFilterSide {
  Both = 'both',
  Requests = 'requests',
  Responses = 'responses',
}

export interface NetworkOutcomeFilter {
  side: NetworkOutcomeFilterSide;
  /** Plain array so React prop comparison works correctly */
  outcomes: NetworkRequestOutcome[];
}

export function makeEmptyNetworkOutcomeFilter(): NetworkOutcomeFilter {
  return { side: NetworkOutcomeFilterSide.Both, outcomes: [] };
}

export function isNetworkOutcomeFilterActive(f: NetworkOutcomeFilter): boolean {
  return f.outcomes.length > 0;
}

export function toggleOutcome(
  f: NetworkOutcomeFilter,
  outcome: NetworkRequestOutcome,
): NetworkOutcomeFilter {
  const already = f.outcomes.includes(outcome);
  return {
    ...f,
    outcomes: already ? f.outcomes.filter((o) => o !== outcome) : [...f.outcomes, outcome],
  };
}

export function setSide(
  f: NetworkOutcomeFilter,
  side: NetworkOutcomeFilterSide,
): NetworkOutcomeFilter {
  return { ...f, side };
}

// ---------------------------------------------------------------------------
// Display helpers — colours match the existing CSS classes in styles.scss
// ---------------------------------------------------------------------------

export interface OutcomeStyle {
  label: string;
  bgColor: string;
  borderColor: string;
  textColor: string;
}

export const OUTCOME_STYLES: Record<NetworkRequestOutcome, OutcomeStyle> = {
  [NetworkRequestOutcome.Succeeded]: {
    label: 'succeeded',
    bgColor: 'rgb(207, 243, 207)',
    borderColor: 'rgb(135, 228, 135)',
    textColor: '#1a6b1a',
  },
  [NetworkRequestOutcome.Failed]: {
    label: 'failed',
    bgColor: 'rgb(240, 153, 153)',
    borderColor: 'rgb(229, 88, 88)',
    textColor: '#7a1a1a',
  },
  [NetworkRequestOutcome.ProbablyFailed]: {
    label: 'failed (maybe)',
    bgColor: 'rgb(220, 153, 240)',
    borderColor: 'rgb(213, 88, 229)',
    textColor: '#5a1a6b',
  },
  [NetworkRequestOutcome.Canceled]: {
    label: 'canceled',
    bgColor: 'rgb(244, 239, 157)',
    borderColor: 'rgb(245, 226, 131)',
    textColor: '#5a4e00',
  },
  [NetworkRequestOutcome.Unknown]: {
    label: 'unknown',
    bgColor: 'rgb(202, 202, 202)',
    borderColor: 'rgb(188, 188, 188)',
    textColor: '#444',
  },
};

export const ALL_NETWORK_OUTCOMES: NetworkRequestOutcome[] = [
  NetworkRequestOutcome.Succeeded,
  NetworkRequestOutcome.Failed,
  NetworkRequestOutcome.ProbablyFailed,
  NetworkRequestOutcome.Canceled,
  NetworkRequestOutcome.Unknown,
];
